module.exports = __webpack_public_path__ + "static/media/cat_face_draw.154a1233.png";